import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { JobTypeState } from '../../store/jobType/job-type-state';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../service/spareparts.service';
// import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-spareparts-management',
  templateUrl: './spareparts-management.component.html',
  styleUrls: ['./spareparts-management.component.less']
})
export class SparepartsManagementComponent implements OnInit {

  validateForm: FormGroup;
  spareTypes = [];
  listOfData = [];
  startRow: number;
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modal: NzModalService,
    public message: NzMessageService,
    private router: Router,
    private dataService: SparepartsService
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
  }


  ngOnInit(): void {
    this.validateForm = this.fb.group({ typeId: null, spareName: null });
    this.initTypeTree(this.store.selectSnapshot<any[]>(JobTypeState));
    this.queryStockData(1);
  }
  /**
   * 初始化 备件类型下拉框
   */
  initTypeTree(types: any[]) {
    for (const type of types) {
      const node = {
        title: type.skillName,
        value: type.skillId,
        key: type.skillId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        this.spareTypes.push(node);
      }
    }
  }
  /**
   * 查询库存数据
   *  @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryStockData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.dataService.queryStockData(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '库存数据查询失败!');
      return;
    } else {
      this.listOfData = result.data.list;
      this.total = result.data.total;
      this.startRow = result.data.startRow;
    }
  }
  submitForm() {
    this.queryStockData(1);
  }

  resetForm() {
    this.validateForm.setValue({ typeId: null, spareName: null });
    this.queryStockData(1);
  }
  /**
   * 删除库存记录
   */
  async deleteData(stNo: number) {
    this.modal.confirm({
      nzTitle: '<i>确认要删除该库存记录信息?</i>',
      nzOkDanger: true,
      nzOnOk: async () => {
        const result = await this.dataService.deleteStockData(stNo);
        if (result.code === undefined || result.code !== 200) {
          this.message.create('error', result.msg);
        } else {
          this.message.create('success', '库存记录删除成功!');
          this.queryStockData(2);
        }
      }
    });
  }

  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.queryStockData(2);
  }
  /**
   * 导出数据
   */
  exportForm() {
    const dataToExport: any[] = [];
    let index = 0;
    this.listOfData.forEach(e => {
      index = index + 1;
      const item = {
        序号: index,
        备件名称: e.spName,
        备件类型: e.tnName,
        库存数量: e.amount,
        备件单位: e.unit,
        备件规格: e.spec,
        备件用途: e.purpose,
        描述: e.description
      };

      dataToExport.push(item);
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 库存数据: worksheet }, SheetNames: ['库存数据'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    const nowstr = new Date();
    const datenow = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
    // FileSaver.saveAs(data, '库存数据' + '_' + datenow + '.xlsx');
  }

  /**
   * 入库单管理
   */
  entrySpareParts() {
    this.router.navigate(['/web/facility/EntrySpareParts']);
  }
  /**
   * 领料单管理
   */
  getSparParts() {
    this.router.navigate(['/web/facility/TakeSpareParts']);
  }
  /**
   * 出库单管理
   */
  outSpareParts() {
    this.router.navigate(['/web/facility/OutSpareParts']);
  }
}
